import React from 'react';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
export function RefundPolicy() {
  return <main className="min-h-screen w-full bg-[#fcfbf7] px-5 py-10 text-[#344833] sm:px-8 sm:py-16" data-id="element-503" data-mp="2bh386qvugqaf">
      <div className="mx-auto max-w-3xl" data-id="element-504" data-mp="2q5h8ov5sg2nt">
        <a href="/" className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.12em] text-[#597050] transition-colors hover:text-[#30452e]" data-id="element-505" data-mp="2q4fvak1av42x">
          <ArrowLeftIcon size={16} data-id="element-506" data-mp="1xh27pcjhrkvh" />
          VOLVER A CÓDIGO FITNESS™
        </a>

        <article className="mt-12 border border-[#e1e4da] bg-[#fffefa] p-7 shadow-[0_12px_35px_rgba(61,75,53,0.07)] sm:p-12" data-id="element-507" data-mp="1siij14dijuzf">
          <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-508" data-mp="27g1682ajm04r">
            INFORMACIÓN LEGAL
          </p>
          <h1 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-509" data-mp="22hzmrg97fysr">
            Política de Reembolsos
          </h1>

          <div className="mt-10 space-y-6 leading-8 text-[#5d6a59]" data-id="element-510" data-mp="3dtqpfio5a083">
            <p data-id="element-511" data-mp="2ikwbq02ix493">
              En Código Fitness™ ofrecemos productos digitales de descarga
              inmediata.
            </p>
            <p data-id="element-512" data-mp="2nio4ewazsuec">
              Una vez realizado el pago, el cliente obtiene acceso instantáneo
              al contenido digital, incluyendo guías, recetarios,
              planificadores, calendarios y demás archivos incluidos en el
              sistema.
            </p>
            <p data-id="element-513" data-mp="1zuoefyli980t">
              Debido a la naturaleza de estos productos, no es posible revocar
              el acceso una vez entregados.
            </p>
            <p data-id="element-514" data-mp="24thg8trfjal5">
              Por esta razón, todas las ventas son finales y no se realizan:
            </p>

            <ul className="grid gap-3 border-l-2 border-[#91a783] pl-5 text-[#405a3b] sm:grid-cols-2" data-id="element-515" data-mp="28sqcq6dutmke">
              {['Reembolsos', 'Cambios', 'Devoluciones', 'Cancelaciones después de la compra'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-516" data-mp="1l35ob7yxlx3q">
                  <CheckIcon size={17} className="text-[#66805c]" data-id="element-517" data-mp="2oeuwqmdzq4rv" />
                  {item}
                </li>)}
            </ul>

            <p data-id="element-518" data-mp="2y5zbpm3o1pmp">
              Te recomendamos leer cuidadosamente la descripción del producto
              antes de realizar tu compra.
            </p>
            <p data-id="element-519" data-mp="2t87d698in59j">
              Si experimentas algún problema técnico para acceder al contenido o
              descargar los archivos, estaremos encantados de ayudarte para
              garantizar que recibas correctamente tu compra.
            </p>
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-[#7a8574]" data-id="element-520" data-mp="2ej1c0fq4b4z0">
          © 2026 Código Fitness™. Todos los derechos reservados.
        </p>
      </div>
    </main>;
}